import Vue from 'vue'
import App from './App.vue'
import Login from "./views/Login.vue";
import Forget from "./views/Forget.vue";
import Register from "./views/Register.vue";
import User from "./views/User.vue";
import './icons' // icon
import VueRouter from 'vue-router'

import { getToken, setToken, getLoginInfo } from '@/utils/auth'
import { getNewToken, checkToken } from "@/api/login"
import NProgress from 'nprogress'
import { setLogin, getFrom, removeFrom } from './utils/auth';

Vue.use(VueRouter)

Vue.config.productionTip = false
const routes = [
  { path: '/', component: Login },
  { path: '/forget', component: Forget },
  { path: '/register', component: Register },
  { path: '/user', component: User }
]
const router = new VueRouter({
  routes
})
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

router.beforeEach((to, from, next) => {
  NProgress.start()
  let token = getToken()
  let loginIfo = getLoginInfo()
  if (!token) {
    getNewToken().then(res => {
      if (res.success) {
        setToken(res.data)
        next({ path: '/' })
        NProgress.done()
      }
    })
  } else if (!loginIfo.isLogin) {
    // 有会话但是前端未校验登录
    checkToken().then(res => {
      if (res.success) {
        setLogin()
        let from = getFrom()
        if (from) {
          removeFrom()
          document.location.href = from
        } else {
          next({ path: '/user' })
        }
      } else {
        if (to.path === '/user') {
          next({ path: '/' })
        } else {
          next()
        }

        NProgress.done()
      }
    })
  } else {
    if (loginIfo.isLogin && to.path !== '/user') {
      next({ path: '/user' })
    } else {
      next()
    }

  }
})

new Vue({
  router: router,
  render: h => h(App),
}).$mount('#app')
